import { render, staticRenderFns } from "./MyHealthAccordion.vue?vue&type=template&id=0befe28c&scoped=true"
import script from "./MyHealthAccordion.vue?vue&type=script&lang=js"
export * from "./MyHealthAccordion.vue?vue&type=script&lang=js"
import style0 from "./MyHealthAccordion.vue?vue&type=style&index=0&id=0befe28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0befe28c",
  null
  
)

export default component.exports